<template>
    <div>
        <self-back :pageHeaderList="[{'name':'账号管理'}]"></self-back>
        <div class="content" v-loading='loading'>
            <button class="addaccountButton" @click="addaccountEvent">+ 添加账号</button>
            <el-select v-model="select_sole_id" clearable style="margin-left:20px;" size="mini" placeholder="请选择">
                <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            <div class="permisssion_hint">
                <i class="el-icon-warning"></i>
                <span>如果更改的是自己的账号角色，更改后，请重新登录！否则不生效！</span>
            </div>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="accountList"
                :max-height="tableMaxHeight"
                border
                >
                <el-table-column
                prop="name"
                label="账号名称"
                align='center'
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="role.name"
                align='center'
                label="角色名称"
                >
                </el-table-column>
                <el-table-column
                prop="real_name"
                align='center'
                label="真实姓名"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                align='center'
                label="手机号"
                >
                </el-table-column>
                <el-table-column
                align='center'
                label="操作">
                    <template slot-scope="scope">
                        <button @click="modifyaccountEvent(scope.row)">修改</button>
                        <button style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationBox">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    @current-change="handleCurrentChange"
                    :page-size="page_size"
                    layout="total, prev, pager, next, jumper"
                    :total="total" />
            </div>
        </div>
        <!-- 添加账号 -->
        <el-dialog
            :title="isEdit?'修改账号':'添加账号'"
            :visible.sync="addaccountFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox">
                <div class="dialogitem" style="margin-bottom: 20px;">
                    <label><em>*</em>账号名称：</label>
                    <el-input
                        placeholder="请输入账号名称"
                        style="width:76%"
                        v-model.trim="accountName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label><em v-if="!isEdit">*</em>账号密码：</label>
                    <el-input
                        :placeholder="isEdit?'填写即认为此账户密码更改为输入内容':'请输入账号密码'"
                        style="width:76%"
                        v-model.trim="accountPassword"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>账号角色</label>
                    <el-select v-model="role_id" size="mini" placeholder="请选择">
                        <el-option
                        v-for="item in roleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>真实姓名：</label>
                    <el-input
                        placeholder="请输入真实姓名"
                        style="width:76%"
                        v-model.trim="real_name"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>手机号：</label>
                    <el-input
                        placeholder="请输入联系方式"
                        style="width:76%"
                        v-model.trim="phone"
                        size='small'
                        clearable>
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
                <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addaccountFlag:false,
            deleteaccountFlag:false,
            accountList:[],
            accountName:'',
            accountPassword:'',
            page:1,
            page_size:20,
            total:0,
            loading:false,
            isEdit:false,
            role_id:'',
            roleList:[],
            select_sole_id:'',
            user_id:'',
            userInfo:{},
            real_name:'',
            phone:''
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件和Footer可见
        tableMaxHeight() {
            // Header(60) + self-back(50) + padding(30) + button(30) + hint(25) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 345px
            // 留一些余量，使用 400px（因为账号管理页面有额外的提示信息）
            return window.innerHeight - 280;
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.rolesListEvent()
        this.accountsListEvent(1)
    },
    methods:{
        rolesListEvent(){
           this.$axios.get(this.URL.BASEURL + this.URL.rolesList,{
               params:{
                   page: 1,
                   page_size: 1000
               }
            }).then((res) => {
                var res=res.data;
                if(res&& res.errno == 0){
                    var arr = res.rst.data;
                    if(this.userInfo.role_id != 12){
                        this.roleList = arr.filter((v)=>{
                            return v.id != 12
                        })
                    }else{
                        this.roleList = arr;
                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
            })
        },
        addaccountEvent(){//点击添加账号按钮
            this.addaccountFlag = true;
            this.isEdit = false;
        },
        deleteaccountFlagEvent(data){//删除账号
            this.$confirm('确定要删除该账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.delUser,{
                        id: data.id
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.accountsListEvent(this.page)
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {
            });
        },
        handleCurrentChange(val){
            this.accountsListEvent(val)
        },
        accountsListEvent(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.users,{
               params:{
                   page: page,
                   page_size: this.page_size,
                   role_id: this.select_sole_id
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    var arr = res.rst.data;
                    if(this.userInfo.role_id != 12){
                        this.accountList = arr.filter((v)=>{
                            return v.role_id != 12
                        })
                    }else{
                        this.accountList = arr;
                    }
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        addaccountYes(){//添加账号
            if(!this.accountName||this.accountName == ''){
                this.$message({
                    message: '请输入账号名称',
                    type: 'fail'
                })
                return
            }
            if(this.role_id == ''){
                this.$message({
                    message: '请选择用户角色',
                    type: 'fail'
                })
                return
            }
            if(!this.real_name||this.real_name == ''){
                this.$message({
                    message: '请输入真实姓名',
                    type: 'fail'
                })
                return
            }
            if(!(/^1[3456789]\d{9}$/.test(this.phone))){
                this.$message({
                    message: '请输入联系方式',
                    type: 'fail'
                })
                return false;
            }
            if(this.isEdit){//编辑
                this.$axios.post(this.URL.BASEURL + this.URL.editUser,{
                    name: this.accountName,
                    password: this.accountPassword,
                    role_id: this.role_id,
                    id: this.user_id,
                    real_name: this.real_name,
                    phone: this.phone
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }else{
                if(this.accountPassword == ''){
                    this.$message({
                        message: '请输入账号密码',
                        type: 'fail'
                    })
                    return
                }
                this.$axios.post(this.URL.BASEURL + this.URL.addUser,{
                    name: this.accountName,
                    password: this.accountPassword,
                    role_id: this.role_id,
                    real_name: this.real_name,
                    phone: this.phone
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }
        },
        cancelAddaccount(){//取消添加账号
            this.addaccountFlag = false;
            this.accountName = '';
            this.role_id = '';
            this.accountPassword = '';
            this.real_name = '';
            this.phone = '';
        },
        modifyaccountEvent(data){//修改账号
            this.accountName = data.name;
            this.user_id = data.id;
            this.role_id = data.role.id;
            this.real_name = data.real_name;
            this.phone = data.phone;
            this.isEdit = true;
            this.addaccountFlag = true;
        }
    },
    watch:{
        select_sole_id(){
            this.accountsListEvent(1)
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 15px;
    // display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .addaccountButton{
        width: 100px;
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        flex-shrink: 0;
    }
    .table{
        margin-top: 15px;
        flex: 1;
        min-height: 0;
        button{
            min-width: 60px;
            height: 26px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
    .paginationBox{
        flex-shrink: 0;
        margin-top: 15px;
        padding-bottom: 0;
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 80px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
        em{
            color: red;
        }
    }
}
.permisssion_hint{
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    color: rgb(255,106,0);
    margin-bottom: 15px;
    margin-left: 15px;
    flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/systemManage/accountManage.vue